if (!customElements.get('faq-accordion')) {
    customElements.define(
        'faq-accordion',
        class FaqAccordion extends HTMLElement {
            connectedCallback() {
                this.addEventListener('click', (event) => {
                    const button = event.target.closest('.faq-question');
                    if (!button) return;
                    this.toggle(button.closest('.faq-item'));
                });
            }

            toggle(item) {
                const isActive = item.classList.contains('active');

                this.querySelectorAll('.faq-item.active').forEach((el) => this.close(el));

                if (!isActive) this.open(item);
            }

            open(item) {
                item.classList.add('active');
                item.querySelector('.faq-question').setAttribute('aria-expanded', 'true');
                const answer = item.querySelector('.faq-answer');
                answer.style.maxHeight = `${answer.scrollHeight}px`;
            }

            close(item) {
                item.classList.remove('active');
                item.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
                item.querySelector('.faq-answer').style.maxHeight = null;
            }
        }
    );
}
